var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{key:'viewKey' + _vm.getViewKey,staticClass:"pa-5",attrs:{"fluid":""}},[_c('the-header'),_c('the-listing')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }